export default "__VITE_ASSET__1b4d5826__"